import {dataTestId} from '@hconnect/uikit'
import {Box, TextField} from '@mui/material'
import Typography from '@mui/material/Typography'
import React, {forwardRef, ChangeEvent} from 'react'
import {FieldError} from 'react-hook-form'

import {CARET_COLOR, SELECTION} from '../../consts'
import {FunctionDefinition} from '../../types'
import {highlightOperatorsAndBrackets} from '../../utils'

const FIELD_MIN_HEIGHT_IN_PX = 72

type FormulaFormFieldProps = {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  functions?: FunctionDefinition[]
  error?: FieldError
}

export const FormulaFormField = forwardRef<HTMLTextAreaElement, FormulaFormFieldProps>(
  ({value, onChange, functions, error}, ref) => {
    return (
      <Box sx={{position: 'relative', width: '100%'}}>
        <TextField
          inputRef={ref}
          value={value}
          placeholder={value}
          onChange={onChange}
          multiline
          minRows={3}
          variant="filled"
          fullWidth
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            caretColor: CARET_COLOR,
            zIndex: 2,
            '& .MuiInputBase-root': {
              color: 'transparent',
              pt: 1
            },
            '&::selection': {
              backgroundColor: SELECTION
            }
          }}
          error={Boolean(error?.message)}
          {...dataTestId('custom_formula_input')}
        />
        <Box
          component="pre"
          sx={{
            margin: 0,
            width: '100%',
            border: '1px solid transparent',
            py: 1,
            px: 1.5,
            minHeight: FIELD_MIN_HEIGHT_IN_PX,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            font: 'inherit',
            lineHeight: 1.4375,
            zIndex: 2,
            pointerEvents: 'none',
            position: 'relative'
          }}
          dangerouslySetInnerHTML={{
            __html: highlightOperatorsAndBrackets(value, functions)
          }}
          {...dataTestId('custom_formula_input_highlighted')}
        />
        {error?.message && (
          <Typography
            position="absolute"
            variant="caption"
            color="error.light"
            sx={{
              mt: 1.75,
              ml: 1.75
            }}
          >
            {error.message}
          </Typography>
        )}
      </Box>
    )
  }
)
